
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSnowShowersDayColour as ObiLightSnowShowersDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-snow-showers-day-colour.js';
 
 
 

 
 export const ObiLightSnowShowersDayColour = createComponent({
   react: React,
   tagName: 'obi-light-snow-showers-day-colour',
   elementClass: ObiLightSnowShowersDayColourElement,
   events: {
     
   }
  });
 
 